import { motion } from 'framer-motion';
import styled from 'styled-components';

import { iconSize, styledInteraction, styledMedia, styledReset } from '@pkg/primitives';

import { emojiPopoverTransition, EmojiPopoverVariant, emojiPopoverVariants } from './EmojiPickerCombo.motion';
import { tokens } from './tokens';

// TODO: We should not be defining arbitrary z-index values.
// This number has been chosen so that it sits above the modal
// used in CreateWishlist.
const TEMP_ZINDEX = 2005;

export const StyledEmojiPickerCombo = styled.div``;

export const Action = styled.button.attrs({ type: 'button' })`
    ${styledReset.button};
    ${styledInteraction.focusRing({ offset: -4, radius: 999 })};
    display: grid;
    place-items: center;
    width: ${tokens.action.size}px;
    height: ${tokens.action.size}px;
    background-color: ${({ theme }) => theme.shades.white[10]};
    border-radius: 999px;
    transition-property: background-color, opacity;
    transition-duration: ${({ theme }) => theme.transitions.speeds.fast}s;
    transition-timing-function: ${({ theme }) => theme.transitions.easesCss.cubic};

    &[disabled],
    &[aria-pressed] {
        opacity: 0.8;
    }

    &:hover {
        background-color: ${({ theme }) => theme.shades.white[15]};
    }

    &:active {
        background-color: ${({ theme }) => theme.shades.white[10]};
    }
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${iconSize.small}px;
    height: ${iconSize.small}px;
`;

interface EmojiPopoverProps {
    $top?: number;
    $right?: number;
}

export const EmojiPopover = styled(motion.div).attrs({
    variants: emojiPopoverVariants,
    initial: EmojiPopoverVariant.Hidden,
    animate: EmojiPopoverVariant.Show,
    exit: EmojiPopoverVariant.Hidden,
    transition: emojiPopoverTransition,
})<EmojiPopoverProps>`
    z-index: ${TEMP_ZINDEX};
    position: fixed;
    top: ${({ $top }) => $top || tokens.popover.top}px;
    right: ${({ $right }) => $right || tokens.popover.right}px;
    border-radius: ${tokens.popover.radius}px;
    // TODO: This should come from the design system.
    background-color: #3b3657;
    transform-origin: center right;
`;
